import * as React from "react";
import { cn } from "@/lib/utils";

// 32 px tall, 1 px border, 2 px indigo focus ring at 1 px offset
// (per MASTER_PROMPT §1.4). Uses the new `bg-input`/`border` tokens so
// inputs feel cohesive across light + dark themes.
export const Input = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ className, type = "text", ...props }, ref) => (
  <input
    type={type}
    ref={ref}
    className={cn(
      "flex h-8 w-full rounded border border-border bg-bg-input px-3 text-base text-text placeholder:text-text-3",
      "transition-colors duration-[120ms] ease-lz",
      "focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/35",
      "disabled:opacity-50",
      className,
    )}
    {...props}
  />
));
Input.displayName = "Input";
